// gatsby-browser.js
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { DARK_THEME } from '@/utils/theme/themes';

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider theme={DARK_THEME}>{element}</ThemeProvider>;
};
